import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import Modal from '@mui/material/Modal';
import {  useParams } from 'react-router-dom';
import { useState, useEffect} from 'react';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';
import { DataGrid, GridColDef, GridToolbar, gridDateComparator } from '@mui/x-data-grid';
import Alert from '@mui/material/Alert';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios';
import { HOST } from '../components/config';

const PreprocessingResultDetail = (props) => {
  const { caseId } = useParams();
  const preprocessingResultId = props.fileProcessingResultId;

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display:'block',
    overflow:'scroll',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    height: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const [resultRuns, setResultRuns] = useState([]);
  const [resultInfo, setResultInfo] = useState([]);
  const [fileInfo, setFileInfo] = useState([]);

  const fetchFileInfo = (file_id) => {
    fetch(HOST + '/api/files/'+ file_id,
    {   
      "method": "GET",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      setFileInfo(json)
   })
  }
  const fetchResultInfo = () => {
    fetch(HOST + '/api/file_processing_step_results/'+ preprocessingResultId,
    {   
      "method": "GET",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      setResultInfo(json)
      fetchFileInfo(json.file_id)
   })
  }
  
  const handleRunDownload = async (run_id) => {
      try {
        const response = await fetch(HOST + '/api/file_processing_step_result_runs/' + run_id, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        const download_url = json['download_url']
        if (download_url){
          window.open(download_url, '_blank')
        }
      } catch (err) {
      }   
    };
  
  const fetchResultRuns = () => {
    fetch(HOST + '/api/file_processing_step_result_runs?file_processing_step_result_id=' + preprocessingResultId,
    {   
      "method": "GET",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      setResultRuns(json)
   })
  }
  useEffect( () => {
    fetchResultInfo()
    fetchResultRuns()
  }, []);

  const handleRerunStep= (event) => {
    fetch(HOST + '/api/file_processing_step_results/' + preprocessingResultId + "/reprocess/",
    {   
      "method": "POST",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      fetchResultRuns()
   })
  }
  
  useEffect( () => {
    fetchResultRuns() 
    
    const intervalId = setInterval(fetchResultRuns, 5000); // Poll every 5 seconds
    
    return () => {
      clearInterval(intervalId); // Clear interval on unmount
    };

  }, []);

  const onCancel = props.onCancel;
  const onUpload = props.onUpload;
  
  const paginationModel = { page: 0, pageSize: 10 };
  const runColumns: GridColDef[] = [
    {
      field: 'created_at',
      headerName: 'Started',
      description: 'The date this result started processing.',
      sortable: true,
      width: 250,
      sortComparator: gridDateComparator, 
      type: 'datetime',
      valueFormatter: (d_s) => d_s.toLocaleString(),
      valueGetter: (value, row) => new Date(row.created_at)
    },
    { 
      field: 'status', 
      headerName: 'Status', 
      width: 130,
      renderCell: (params) => params.row.status == 'SUCCESS' ? 
        (<Chip  className="chip-boxy" label="Success" color="success" variant="outlined" />) : 
        params.row.status == 'ERROR' ?  
        (<Chip label="Errored"  className="chip-boxy" color="error" variant="outlined" />) :
        (<Chip label="Running"  className="chip-boxy" color="info" variant="outlined" />) 

    },
    { 
      field: 'updated_at', 
      headerName: 'Updated At', 
      width: 250,
      sortComparator: gridDateComparator, 
      type: 'datetime',
      valueFormatter: (d_s) => d_s.toLocaleString(),
      valueGetter: (value, row) => new Date(row.updated_at)
    },
    {
      field: 'action',
      headerName: 'Actions',
      sortable: false,
      width: 150,
      renderCell: (params) =>  (
      <>
        <IconButton onClick={() => handleRunDownload(params.row.id)}
          size='large' >
          <CloudDownloadIcon /> 
        </IconButton> 
    </>)
    },
  ];
  return (<Modal
    open={true}
    onClose={onCancel}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
  >
  <Box sx={modalStyle}>
    <Typography id="modal-modal-title" variant="h6" component="h2">
      {resultInfo.processing_step_label} File Processing: 
      {fileInfo && 
        <> {fileInfo.filename}</>
      }
    </Typography>
      <Button variant="contained" color="primary" component="span" onClick={() => handleRerunStep()}>
        Reprocess 
      </Button>
      
      <DataGrid
        rows={resultRuns}
        columns={runColumns}
        initialState={{ sorting: { sortModel: [ { field: "created_at", sort: 'desc' }]}, pagination: { paginationModel } }}
        pageSizeOptions={[10, 25, 50, 100]}
        disableColumnSelector
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: { disableToolbarButton: true },
            showQuickFilter: true,
          },
        }}
        sx={{ border: 0 }}
      />
  </Box>
  </Modal>)
}

export default PreprocessingResultDetail;
